import React, { Component } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CampaignDashboardHeader from '../../components/campaign-dashboard-header';
import TabActionBar from '../../components/tab-action-bar';
import DataRequestsListing from '../../components/data-requests-listing';

import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasUserInfo from '../../hocs/has-user-info';

import {
  DATA_REQUESTS_RESOURCE,
} from '../../utils/helpers/resources';

class AgencyInfluencerRequests extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      isError: false,
      requests: [],
    };
  }

  componentDidMount() {
    const { jsonAPIClient, userInfo } = this.props;
    const { organisationId } = userInfo;

    jsonAPIClient.find(DATA_REQUESTS_RESOURCE, { // eslint-disable-line lodash/prefer-lodash-method
      include: ['agency', 'influencer'],
      filter: {
        agency: organisationId,
      },
    }).then(response => {
      const json = _.map(response, (item => item.toJSONTree()));
      this.setState({
        requests: json,
        isLoading: false,
        isError: false,
      });
    }).catch(() => {
      this.setState({
        isLoading: false,
        isError: true,
        requests: [],
      });
    });
  }

  onViewModeChanged = () => {
    console.log('view mode changed');
  }

  render() {
    const { isLoading, isError, requests } = this.state;
    return (
      <div className="page">
        <CampaignDashboardHeader
          name="My Requests"
        />
        <div className="page-content">
          <TabActionBar
            onViewModeChanged={this.onViewModeChanged}
          />
          <DataRequestsListing
            isLoading={isLoading}
            isError={isError}
            requests={requests}
          />
        </div>
      </div>
    );
  }
}


AgencyInfluencerRequests.propTypes = {
  userInfo: PropTypes.object.isRequired,
  jsonAPIClient: PropTypes.object.isRequired,
};

export default compose(
  hasJSONAPIClient,
  hasUserInfo,
)(AgencyInfluencerRequests);



/** WEBPACK FOOTER **
 ** ./src/containers/agency-influencer-requests/index.js
 **/